var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInventory = function SvgInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 18 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.238.015q.351.046.677.234l7.17 4.118q.435.25.675.665t.24.913v8.11a1.79 1.79 0 0 1-.915 1.578l-7.17 4.119a1.8 1.8 0 0 1-.677.233L9 20q-.482 0-.915-.248l-7.17-4.12A1.785 1.785 0 0 1 0 14.055V5.946a1.79 1.79 0 0 1 .915-1.578L8.085.25Q8.52-.001 9 0zM1.392 14.038q.001.11.056.208.056.095.155.158h.002l.005.004 6.532 3.778.162.093v-7.88L1.392 6.405zm8.304-3.64v7.881l.162-.093 6.53-3.778.01-.006a.46.46 0 0 0 .154-.156.4.4 0 0 0 .056-.208V6.405zM4.82 3.73 2.169 5.261 9 9.201l.054-.03 2.65-1.532-6.83-3.94zM9 1.378a.4.4 0 0 0-.217.065l-.002.002-2.487 1.429.161.093 6.623 3.81.053.03.053-.03 2.646-1.516-6.612-3.816h-.002A.4.4 0 0 0 9 1.377"
  })));
};
export default SvgInventory;